import { WeatherContext } from 'pages/Forecast';
import { useContext } from 'react';
import 'styles/global.css';
import DataGridDisplay from 'components/DataGridDisplay/DataGridDisplay';
import { GetWeatherDateString } from 'utils/stringUtils';
import { PiWavesBold } from 'react-icons/pi';
import { GetQualityColor } from 'utils/colorUtils';
import { Accordion } from 'react-bootstrap';

export default function AirQualityForecast() {
  const weatherContext = useContext(WeatherContext);

  const getFilteredData = (station) =>
    weatherContext?.airQuality?.forecast.data.filter(
      (filter) => filter.air_station_name === station,
    );

  const getAverageCategory = (stationData) => {
    const categoryCountsMap = new Map();

    stationData.forEach((data) => {
      const category = data?.category;

      if (category !== '*') return;

      if (!categoryCountsMap.has(category)) {
        categoryCountsMap.set(category, 0);
      } else {
        categoryCountsMap.set(category, categoryCountsMap.get(category) + 1);
      }
    });

    if (Object.keys(categoryCountsMap).length === 0) return;

    const highestCategory = Object.entries(categoryCountsMap).reduce((max, [key, value]) => {
      return categoryCountsMap.get(max) > value ? max : key;
    })[0];
    return highestCategory;
  };

  return (
    <Accordion>
      {weatherContext?.airQuality?.forecast?.stations &&
        weatherContext?.airQuality?.forecast?.stations?.map((station, index) => {
          return (
            <Accordion.Item key={station} eventKey={index}>
              <Accordion.Header>
                <div className="d-flex flex-row justify-content-between w-100">
                  <div>{station}</div>
                  <div>
                    <PiWavesBold
                      size={25}
                      color={GetQualityColor(getAverageCategory(getFilteredData(station)))}
                    />
                  </div>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className="d-flex flex-column gap-3">
                  {getFilteredData(station).map((item, itemIndex) => (
                    <DataGridDisplay
                      key={`${station}-${item.iso8601}-${itemIndex}`}
                      title={GetWeatherDateString(new Date(item?.iso8601))}
                      icon={<PiWavesBold size={25} color={GetQualityColor(item?.category)} />}
                    >
                      <div className="d-flex flex-row justify-content-between">
                        <div>{`Concentration: ${item.concentration || '*'}ppb`}</div>
                        <div>{`Category: ${item.category || '*'}`}</div>
                      </div>
                    </DataGridDisplay>
                  ))}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
    </Accordion>
  );
}
